<template>
  <ion-row
    v-if="rentalUnit.Prices && rentalUnit.Prices[0]"
    class="ion-justify-content-start ion-align-items-baseline price-subtitle"
  >
    <h1 class="font-md bold-medium primary">
      {{
        amountMask(rentalUnit.Prices[0].amount as number, rentalUnit.Prices[0].currency as string)
      }}/
    </h1>
    <p v-if="rentalUnit.Prices && rentalUnit.Prices[0]" class="font-sm grey padding-x">
      {{
        t(
          `announcement.${rentalUnit.Prices[0].paymentCycle !== 'Unknown' ? rentalUnit.Prices[0].paymentCycle : 'monthly'}`,
        )
      }}
    </p>
  </ion-row>
</template>

<script setup lang="ts">
  import { IonRow } from '@ionic/vue';
  import { RentalUnit } from '@/interfaces/elastic/elastic.interface';
  import { amountMask } from '@/utils/validations/formats';
  import { useI18n } from 'vue-i18n';

  withDefaults(
    defineProps<{
      rentalUnit: RentalUnit;
    }>(),
    {},
  );

  const { t } = useI18n();
</script>

<style lang="css" scoped></style>
